import { WORKKARD_DETAIL_MASTER_DATA_SUCCESS, WORKKARD_DETAIL_MASTER_DATA_ERROR, RESET_WORKKARD_DETAIL_DATA, FETCH_WORKKARD_CARRIER_SUCCESS } from "../actions/actionConstants";

const initialState = {
  pinned_fields: [],
  customFieldsOrderVersion: 0,
};

const toOrderedCfKeys = (pinnedFields) => {
  if (!Array.isArray(pinnedFields) || !pinnedFields.length) return [];
  return pinnedFields
    .slice()
    .sort((a, b) => a.seq_no - b.seq_no)
    .map(({ cf_key }) => cf_key);
};

const reorderCustomFieldsByPinnedFields = (customFields, pinnedFields) => {
  if (!Array.isArray(customFields) || !customFields.length) {
    return customFields;
  }

  const pinnedOrder = toOrderedCfKeys(pinnedFields);
  if (!pinnedOrder.length) {
    return customFields.slice().sort((a, b) => (a.Sequence || 0) - (b.Sequence || 0));
  }

  const pinnedIndexByName = pinnedOrder.reduce((acc, name, index) => {
    acc[name] = index;
    return acc;
  }, {});

  const pinned = [];
  const unpinned = [];
  customFields.forEach(field => {
    if (Object.prototype.hasOwnProperty.call(pinnedIndexByName, field.Name)) {
      pinned.push(field);
    } else {
      unpinned.push(field);
    }
  });

  pinned.sort((a, b) => pinnedIndexByName[a.Name] - pinnedIndexByName[b.Name]);
  unpinned.sort((a, b) => (a.Sequence || 0) - (b.Sequence || 0));

  return [...pinned, ...unpinned].map((field, index) => Object.assign({}, field, { Sequence: index }));
};

export default function (state = initialState, action) {
  switch (action.type) {
    case WORKKARD_DETAIL_MASTER_DATA_SUCCESS: {
      const { resetPinnedFields, ...incoming } = action.payload;
      const pinned_fields = (incoming.pinned_fields && (incoming.pinned_fields.length || resetPinnedFields))
        ? incoming.pinned_fields
        : state.pinned_fields;
      const mergedState = Object.assign({}, state, incoming, { pinned_fields });
      if (mergedState.CustomFields) {
        mergedState.CustomFields = reorderCustomFieldsByPinnedFields(mergedState.CustomFields, pinned_fields);
        mergedState.customFieldsOrderVersion = (state.customFieldsOrderVersion || 0) + 1;
      }
      return mergedState;
    }
    case WORKKARD_DETAIL_MASTER_DATA_ERROR: {
      return Object.assign({}, state, action.payload);
    }
    case RESET_WORKKARD_DETAIL_DATA:
      return Object.assign(
        {},
        initialState
      );
    case FETCH_WORKKARD_CARRIER_SUCCESS: {
      return Object.assign({}, state, {workkardCarriers:action.payload});
    }
    default:
      return state;
  }
}
